import { Select } from "antd";
import { useEffect, useState } from "react";
import { ColumnFilterWrapper } from "./ColumnFilterWrapper";

export default function CustomSelectFilter({
  title,
  before,
  options,
  loading,
  onSearch,
  onApply,
  selectedValues,
  placeholder,
  close,
  confirm,
}: {
  title?: string;
  before?: React.ReactNode;
  options: { value: string; label: string }[];
  loading: boolean;
  onSearch: (value: string) => void;
  onApply: (values: string[]) => void;
  selectedValues: string[];
  placeholder: string;
  close: () => void;
  confirm: () => void;
}) {
  const [tempValues, setTempValues] = useState<string[]>(selectedValues);
  const [selectedOptionsData, setSelectedOptionsData] = useState<
    { value: string; label: string }[]
  >([]);

  useEffect(() => {
    setTempValues(selectedValues);
  }, [selectedValues]);

  useEffect(() => {
    const newSelectedData = tempValues.map((val) => {
      const existing =
        options.find((opt) => opt.value === val) ||
        selectedOptionsData.find((opt) => opt.value === val);
      return existing || { value: val, label: val };
    });
    setSelectedOptionsData(newSelectedData);
  }, [tempValues, options]);

  const finalOptions = [...options];
  const optionValues = new Set(options.map((opt) => opt.value));

  selectedOptionsData.forEach((opt) => {
    if (!optionValues.has(opt.value)) {
      finalOptions.push(opt);
    }
  });

  const isFiltered = tempValues.length > 0;

  const cleanPlaceholder = placeholder
    ? placeholder.replace(/^(Select|Choose)\s+/i, "")
    : "";
  const displayTitle =
    title ||
    (cleanPlaceholder
      ? cleanPlaceholder.charAt(0).toUpperCase() + cleanPlaceholder.slice(1)
      : undefined);

  return (
    <ColumnFilterWrapper
      title={displayTitle}
      filterCount={tempValues.length}
      onReset={() => {
        setTempValues([]);
        onApply([]);
        confirm();
        close();
      }}
      onApply={() => {
        onApply(tempValues);
        confirm();
        close();
      }}
      onClose={close}
      before={before}
    >
      <div style={{ padding: "8px 4px" }}>
        <Select
          options={finalOptions}
          placeholder={placeholder}
          mode="multiple"
          loading={loading}
          showSearch
          filterOption={false}
          value={tempValues}
          onChange={(val) => setTempValues(val)}
          onSearch={onSearch}
          style={{ width: "100%" }}
          maxTagCount={3}
        />
      </div>
    </ColumnFilterWrapper>
  );
}
